import { render, staticRenderFns } from "./ClassicMeter.vue?vue&type=template&id=4b4c1f24&scoped=true&"
import script from "./ClassicMeter.vue?vue&type=script&lang=ts&"
export * from "./ClassicMeter.vue?vue&type=script&lang=ts&"
import style0 from "./ClassicMeter.vue?vue&type=style&index=0&id=4b4c1f24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4c1f24",
  null
  
)

export default component.exports